import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-导入任务管理",
  "use": "icon-导入任务管理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-导入任务管理\"><path d=\"M482.4 96a32 32 0 0 1 64 0v384h128a32 32 0 0 1 22.624 54.624l-160 160a32 32 0 0 1-45.248 0l-160-160A32 32 0 0 1 354.4 480h128V96z\" fill=\"#81818c\" p-id=\"1872\" /><path d=\"M160 768h704a32 32 0 0 1 0 64H160a32 32 0 0 1 0-64z\" fill=\"#81818c\" p-id=\"1873\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol